export default __webpack_public_path__ + "static/media/message.68148cd3.png";